import { render, staticRenderFns } from "./CitySelectList copy.vue?vue&type=template&id=2579cf86&"
import script from "./CitySelectList copy.vue?vue&type=script&lang=js&"
export * from "./CitySelectList copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports